export { default } from './Checkbox';


//////////////////
// WEBPACK FOOTER
// ./~/perx-uikit/~/rc-checkbox/es/index.js
// module id = 765
// module chunks = 5